import { useState } from 'react'

interface ChatHeaderProps {
  onClose: () => void
  className?: string
  title?: string
  showNewMessage?: boolean
  showHistory?: boolean
  onNewChat?: () => void
  onShowHistory?: () => void
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({
  onClose,
  className,
  title = 'Walter AI',
  showNewMessage = true,
  showHistory = true,
  onNewChat,
  onShowHistory
}) => (
  <div
    className={`flex items-center justify-between bg-[#2E6CFF] p-4 ${className || ''}`}
  >
    <div className='flex items-center gap-4'>
      <h3 className='font-medium text-white'>{title}</h3>
    </div>
    <div className='flex items-center gap-4'>
      {showNewMessage && (
        <img
          src='/images/message-add-alt.svg'
          alt='New message'
          width={20}
          height={20}
          className='cursor-pointer'
          onClick={onNewChat}
        />
      )}
      {showHistory && (
        <img
          src='/images/history.svg'
          alt='History'
          width={20}
          height={20}
          className='cursor-pointer'
          onClick={onShowHistory}
        />
      )}
      <div className='h-5 w-[1px] bg-white opacity-20'></div>
      <button
        onClick={onClose}
        className='text-white transition-colors hover:text-gray-200'
      >
        <img src='/images/close.svg' alt='Close' width={20} height={20} />
      </button>
    </div>
  </div>
)
